import { useEffect, useRef, useState } from 'react';
import aim from '../assets/samples/anima.gif'
import { useNavigate } from 'react-router-dom';
import customize_icon from '../assets/icon/customize.svg'
import './presets_main.css';

function P_card({item, theme}) {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 480);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Carousel Logic
    const imageSet = item && item.images && item.images.length > 0 ? item.images : (item && item.src ? [item.src] : []);
    
    useEffect(() => {
        if (isHovered && imageSet.length > 1) {
            intervalRef.current = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % imageSet.length);
            }, 1500); 
        } else {
            clearInterval(intervalRef.current);
            setCurrentIndex(0); 
        }
        return () => clearInterval(intervalRef.current);
    }, [isHovered, imageSet.length]);

    const [load, setLoad] = useState(false)
    const [uni, setUni] = useState()
    const [Str, setStr] = useState("")

    useEffect(()=>{
        if (item && item.fabrics && Array.isArray(item.fabrics)) {
            var a = [];
            var S = "";
            item.fabrics.forEach(element => {
                if(!a.includes(element.type)){
                    a.push(element.type)
                    S+= "/"+element.type+"=brand?"+element.brand+"&fabric?"+element.name
                }
            });
            setStr(S)
            setUni(a)
        }
    }, [item])

    const navigate = useNavigate()
    const counter = useRef(0);

    if (!item) return null;

    const imageLoaded = () => {
        counter.current += 1;
        let L = 1;
        if (counter.current >= L) {
            setLoad(false);
            counter.current = 0;
        }
    }

    const itemName = item.name || item.title || "Item";
    const itemSrc = item.src || item.img;
    const productUrl = `/products/${item.category || 'unknown'}/${itemName.replace(/ /g, "-")}/${item.doc || 'unknown'}`;

    const deliverBy = (() => {
        const d = new Date();
        d.setDate(d.getDate() + 13);
        return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    })();

    // Price Logic: Handle both 'price' and 'Price' (case sensitivity from DB)
    const rawPrice = item.price !== undefined ? item.price : (item.Price !== undefined ? item.Price : 0);
    const itemPrice = Number(rawPrice) || 0;
    
    const rawDiscount = item.discount !== undefined ? item.discount : (item.Discount !== undefined ? item.Discount : 0);
    const itemDiscount = Number(rawDiscount) || 0;
    
    const discountedPrice = itemDiscount > 0 
        ? (itemPrice - itemPrice * (itemDiscount / 100))
        : null;

    const formatPrice = (val) => {
        const numVal = Number(val);
        // Don't show 0 if it's invalid, but allow 0 if it's explicitly 0 (though unlikely for products)
        // If val was missing/undefined, itemPrice became 0. 
        // We should check if the original item had a price.
        
        if (isNaN(numVal)) return "₹0";
        
        return numVal.toLocaleString('en-IN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            style: 'currency',
            currency: 'INR'
        });
    };

    const handleCardClick = () => {
        window.scrollTo(0, 0);
        try {
            const cleanItem = JSON.parse(JSON.stringify(item));
            navigate(productUrl, { state: { sel: cleanItem } });
        } catch (error) {
            console.error("Failed to clone item for navigation state:", error);
            // Fallback: navigate without state, let the destination fetch data by ID
            navigate(productUrl);
        }
    };

    // SVG icons inline
    const HeartIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
    );
    const ShareIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
    );
    const BagIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
    );

    return ( 
        <div 
            className={`product-card ${theme?.cardBg || ''} ${theme?.borderColor || ''} ${theme?.shadow || ''}`} 
            onClick={handleCardClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{ 
                border: 'none',
                // Apply theme styles if provided, otherwise default
                backgroundColor: theme?.cardBg ? undefined : 'rgba(255, 255, 255, 0.6)'
            }}
        >
            {/* Image Section */}
            <a href={productUrl} style={{textDecoration:"none", color:"inherit"}} onClick={(e) => e.preventDefault()}>
                <div className="product-card-image">
                    {load && 
                        <div style={{width:"100%", height:"100%", backgroundColor:"white", position:"absolute", display:"flex", alignItems:"center", justifyContent:"center", zIndex:3}}>
                            <img src={aim} style={{width:"70px"}} alt="loading"/>
                        </div>
                    }
                    {!load && imageSet.length > 0 && imageSet.map((imgSrc, idx) => (
                         <img 
                            key={idx}
                            src={imgSrc || itemSrc} 
                            alt={itemName}
                            onLoad={imageLoaded}
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-in-out ${idx === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
                            style={{ 
                                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover',
                                opacity: idx === currentIndex ? 1 : 0, zIndex: idx === currentIndex ? 10 : 0
                            }}
                        />
                    ))}
                    {!load && imageSet.length === 0 && itemSrc && (
                         <img 
                            src={itemSrc} 
                            alt={itemName}
                            onLoad={imageLoaded}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    )}

                    {/* Badges */}
                    <div className="product-card-badge">Best Seller</div>

                    {(item.customize || item.customizable) && 
                        <div className="product-card-customize-badge">
                            <img src="/media/site/customize.gif" alt="customizable"/>
                        </div>
                    }

                    {item.discount && Number(item.discount) > 0 &&
                        <div className="product-card-discount-badge">
                            {item.discount}% OFF
                        </div>
                    }
                </div>
            </a>

            {/* Info Section */}
            <div className={`product-card-info ${theme?.cardBg || ''}`} style={{ backgroundColor: theme?.cardBg ? 'transparent' : 'white' }}>
                <h3 className={`product-card-name ${theme?.titleColor || ''} ${theme?.titleFont || ''}`} style={{ color: theme?.titleColor ? undefined : '#14213D' }}>
                    {itemName.split('').map((char, index) => (
                        <span key={index} style={{ fontFamily: /\d/.test(char) ? 'Manrope, sans-serif' : 'inherit' }}>
                            {char}
                        </span>
                    ))}
                </h3>
                <p className={`product-card-delivery ${theme?.descColor || ''}`} style={{ color: theme?.descColor ? undefined : '#888' }}>Delivered by {deliverBy}</p>

                <div className="product-card-price-row" style={{justifyContent: 'space-between', width: '100%'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        {discountedPrice ? (
                            <>
                                <span className={`product-card-price ${theme?.textColor || ''}`} style={{ color: theme?.textColor ? undefined : '#14213D' }}>{formatPrice(discountedPrice)}</span>
                                <span className="product-card-original-price">{formatPrice(itemPrice)}</span>
                            </>
                        ) : (
                            <span className={`product-card-price ${theme?.textColor || ''}`} style={{ color: theme?.textColor ? undefined : '#14213D' }}>{formatPrice(itemPrice)}</span>
                        )}
                    </div>

                    {/* Actions - desktop only (hidden on mobile via CSS) */}
                    <div className="product-card-actions" style={{marginTop: 0}}>
                        <button className={`product-card-action-btn ${theme?.buttonTextColor || ''}`} onClick={(e) => e.stopPropagation()} title="Wishlist">
                            <HeartIcon />
                        </button>
                        <button className={`product-card-action-btn ${theme?.buttonTextColor || ''}`} onClick={(e) => e.stopPropagation()} title="Share">
                            <ShareIcon />
                        </button>
                        <button className={`product-card-action-btn ${theme?.buttonTextColor || ''}`} onClick={(e) => e.stopPropagation()} title="Add to bag">
                            <BagIcon />
                        </button>
                    </div>
                </div>

                <div className="product-card-prepaid">Extra 5% off on Prepaid Orders</div>
            </div>
        </div>
    );
}

export default P_card;